import templateContent from './templates/generatePostContent.txt?raw';

export interface GeneratePostContentPromptParams {
  content: string;
}

/**
 * ブログ記事のコンテンツ生成用プロンプトを生成する
 * テンプレートファイルから読み込んだプロンプトにパラメータを埋め込む
 * 
 * @param params プロンプト生成パラメータ
 * @returns 生成されたプロンプト文字列
 */
export const generatePostContentPrompt = (
  params: GeneratePostContentPromptParams
): string => {
  const { content } = params;
  
  // テンプレートの置換
  const prompt = templateContent
    .replace('{{CONTENT}}', content.trim());
  
  return prompt;
};

